export default {"src":"/_next/static/media/MYR.f8eaf02c.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};